<template>
  <div class="pa-4">
    <v-dialog v-model="dialog" v-if="dialog" scrollable max-width="90%" height="90%" persistent :transition="false">

      <v-card class="mt-2 py-2">
        <v-card-title class="">
            <span class="text-h5">Stock Opname Detail</span>
            <v-spacer></v-spacer>
            <v-icon color="white" @click="dialog = false">mdi-close</v-icon>
        </v-card-title>    
        <v-divider></v-divider>
        <v-card-text class="mt-3">
          <v-row class="mx-2 py-0 compact-form">
            <v-col cols="6">
              <v-layout class="my-2">
                <v-flex align-self-center md4><strong>Tanggal Stock Opname:</strong></v-flex>
                <v-flex md8>
                  {{ date_count | moment }}
                </v-flex>
              </v-layout>
            </v-col>
            <v-col cols="6">
              <v-layout class="my-2">
                <v-flex align-self-center md4><strong>Type:</strong></v-flex>
                <v-flex md8>
                  <v-chip small color="primary" text-color="white">
                    {{ typeName }}
                  </v-chip>
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>

          <v-row class="mb-2 mt-3">
            <v-col class="ml-2">
              <v-card outlined class="ma-3" width="980px">
                <v-simple-table fixed-header height="400px" id="variantTbl">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">No</th>
                        <th class="text-left">Code</th>
                        <th class="text-left">Description</th>
                        <th class="text-right">Estimasi Stok Akhir</th>
                        <th class="text-right">Qty Count</th>
                        <th class="text-right">Selisih (kg)</th>
                        <th class="text-right">Deviasi (%)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, vidx) in items" :key="vidx">
                        <td>{{ vidx + 1 }}</td>
                        <td>{{ item.code }}</td>
                        <td>{{ item.description }}</td>
                        <td class="text-right">{{ item.estimasi_stok_akhir | rounded2 }}</td>
                        <td class="text-right">{{ (item.qty_count_temp || item.qty_count || 0) | rounded2 }}</td>
                        <td class="text-right" :class="getDifferenceClass(item)">
                          {{ getDifference(item) | rounded2 }}
                        </td>
                        <td class="text-right" :class="getDeviationClass(item)">
                          {{ getDeviation(item) | rounded2 }}%
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>   

        <v-divider></v-divider>
        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">Close</v-btn>
        </v-card-actions> 
      </v-card>
    </v-dialog>
    
    <v-overlay :value="onProgress" z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>        

  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      onProgress: false,
      dialog: false,
      date_count: null,
      items: [],
      rawMaterials: null
    }
  },
  computed: {
    variants() {
      return this.$store.state.variant.objs
    },
    typeName() {
      if (this.$route.params.type=='RM') return 'Bahan Baku'
      else if (this.$route.params.type=='LB') return 'Label & Botol'
      else return 'Finished Goods'
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('D MMMM YYYY');
    },
    rounded2: function (value) {
      if (!value) return '0.00'
      return Number(value).toFixed(2)
    }
  },
  methods: {
    async openDialog() {
      this.onProgress = true
      this.items = []
      this.dialog = true

      await this.$store.dispatch('variant/getObjs')
      
      if (!this.date_count){
        console.error('date_count is required for stock opname detail')
        this.onProgress = false
        return
      }
      
      let dt = new Date(this.date_count + " 00:00:00")
      dt.setDate(dt.getDate() - 6)
      dt = moment(dt).format('YYYY-MM-DD')
      
      console.log('Detail - date_count:', this.date_count, 'dt:', dt)
      
      // Load raw materials data
      if (this.$route.params.type=='RM')
        this.rawMaterials = (await this.$store.dispatch('getObjs',{apidomain:'others/frm005/', parameter:dt})).data
      else if (this.$route.params.type=='LB')
        this.rawMaterials = (await this.$store.dispatch('getObjs',{apidomain:'others/frm005lb/', parameter:dt})).data
      
      // Load stock opname items
      this.items = (await this.$store.dispatch('getObjs', {apidomain:'stockOpnames/show?type='+this.$route.params.type+'&date_count='+this.date_count, parameter:''})).data.data
      
      // Enrich items with descriptions and estimations
      this.items.forEach(el => {
        let obj = {}
        if (this.$route.params.type=='RM' || this.$route.params.type=='LB') {
          obj = this.rawMaterials.find(item => (item.code === el.code))
          if (obj) {
            this.$set(el, 'description', obj.description)
            this.$set(el, 'estimasi_stok_akhir', Number(obj.stok_aktual_awal) + Number(obj.stockin_total) - Number(obj.use_total))
          }
        }
        else {
          obj = this.variants.find(item => item.code === el.code)
          if (obj) {
            this.$set(el, 'description', obj.name)
          }
        }
      })
      
      console.log('Detail items:', this.items)
      this.items.sort((a, b) => {
        const aDesc = a.description || '';
        const bDesc = b.description || '';
        return aDesc.localeCompare(bDesc);
      })
      
      this.onProgress = false
    },

    getDifference(item) {
      const qtyCount = Number(item.qty_count_temp || item.qty_count || 0);
      const estimasi = Number(item.estimasi_stok_akhir || 0);
      return qtyCount - estimasi;
    },

    getDeviation(item) {
      const qtyCount = Number(item.qty_count_temp || item.qty_count || 0);
      const estimasi = Number(item.estimasi_stok_akhir || 0);
      if (estimasi === 0) return 0;
      return ((qtyCount - estimasi) / estimasi) * 100;
    },

    getDifferenceClass(item) {
      const diff = this.getDifference(item);
      if (diff > 0) return 'green--text font-weight-bold';
      if (diff < 0) return 'red--text font-weight-bold';
      return '';
    },

    getDeviationClass(item) {
      const deviation = Math.abs(this.getDeviation(item));
      if (deviation > 10) return 'red--text font-weight-bold';
      if (deviation > 5) return 'orange--text font-weight-bold';
      return '';
    }
  }
}
</script>

<style>
  #orderform .col {
    padding: 5px!important;
  }
</style>
